function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_282_299763)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28 27.69V4C28 1.8 26.2 0 24 0H11.58L7.58 4L4 7.4L0 11.4V27.69C0 29.89 1.8 31.69 4 31.69H24C26.2 31.69 28 29.89 28 27.69ZM13.15 4.08V11.65H5.57L13.14 4.08H13.15ZM4 15.66H13.15C15.35 15.66 17.15 13.86 17.15 11.66V4H24V27.69H4V15.66Z",
  fill: "black",
  fillOpacity: 0.65
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.9492 8.33008H29.9292V12.3301H31.9492V36.0201H11.9492V33.6201H7.94922V36.0201C7.94922 38.2201 9.74922 40.0201 11.9492 40.0201H31.9492C34.1492 40.0201 35.9492 38.2201 35.9492 36.0201V12.3301C35.9492 10.1301 34.1492 8.33008 31.9492 8.33008Z",
  fill: "black",
  fillOpacity: 0.65
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_282_299763"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
})));

var SvgViewPayBills = function SvgViewPayBills(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgViewPayBills, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/view-pay-bills.3b024ad4.svg";
export { ForwardRef as ReactComponent };